function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#6E6E6F;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6e6e6f",
  d: "M48.1,14H33.7v9.3c0,5.2-3.8,9.6-8.9,10.3v3.7c0,4.8,3.9,8.6,8.6,8.6h14.6c4.8,0,8.6-3.9,8.6-8.6V22.7 C56.7,17.9,52.9,14,48.1,14L48.1,14z M45.2,37.8l-1.3-4h-6.1l-1.3,4h-3l6-17.1h2.7l5.9,17.1H45.2z M40.8,24.7l-2.2,6.8h4.5 L40.8,24.7L40.8,24.7z M21.8,39.9c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.1-0.4,0.4-0.4,0.6l0,0.8c-4.5,0.3-8.7-2-10.8-6l0.8-0.5 c0.2-0.1,0.4-0.4,0.3-0.7c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.1-0.3-0.1L8.3,33C8,33,7.6,33.2,7.5,33.5c0,0,0,0,0,0l0,0.1l-0.5,2 c-0.1,0.3,0,0.5,0.3,0.7c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1l0.8-0.5c2.2,4.2,6.6,6.8,11.3,6.7c0.2,0,0.4,0,0.7,0l0,0.9 c0,0.3,0.2,0.5,0.4,0.6c0.1,0,0.2,0,0.2,0c0.2,0,0.4-0.1,0.5-0.2l1.5-1.6c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5L21.8,39.9z  M23.3,31.9c4.8,0,8.6-3.9,8.6-8.6V8.6c0-4.8-3.9-8.6-8.6-8.6H8.6C3.9,0,0,3.9,0,8.6v14.6c0,4.8,3.9,8.6,8.6,8.6L23.3,31.9z  M9.7,14.5l3-0.7v-1l-3,0.7v-2.2l3-0.7V8.1h3.1v1.7l3-0.7v2.2l-3,0.7v1l3-0.7v2.2l-3,0.7v5.6c0.5-0.1,1-0.3,1.4-0.6 c0.4-0.3,0.8-0.6,1.1-1c0.3-0.4,0.5-0.9,0.7-1.4c0.2-0.6,0.2-1.1,0.2-1.7h3.1c0,1.1-0.2,2.2-0.6,3.2c-0.4,0.9-0.9,1.7-1.6,2.4 c-0.7,0.7-1.6,1.2-2.6,1.5c-1.1,0.4-2.2,0.5-3.4,0.5c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7-0.1v-7.6l-3,0.7L9.7,14.5z"
});

var SvgTranslate = function SvgTranslate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 46",
    style: {
      enableBackground: "new 0 0 56.7 46"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranslate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/translate.1e5cffc7.svg";
export { ForwardRef as ReactComponent };